/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ProcessCreatePage = lazyLoad(
  () => import('./index'),
  module => module.ProcessCreatePage
);
